<template>
    <div ref="colorsRef" role="radiogroup" class="flex gap-2" data-test="colors">
        <div
            v-for="(option, index) of THREAD_CATEGORY_COLORS_OPTIONS"
            :key="option.value"
            role="radio"
            :aria-checked="color === option.value"
            :aria-label="option.label"
            :tabindex="index === colorTabStop ? 0 : -1"
            class="cursor-pointer hover:scale-110 active:scale-90 rounded size-10 transition outline outline-2 outline-offset-2 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-4"
            :class="color === option.value ? '' : 'outline-transparent'"
            :style="{
                backgroundColor: '#' + option.value,
                ...(color === option.value ? { outlineColor: '#' + option.value } : {}),
            }"
            :data-test="`color-${option.label}`"
            @click="choose(option.value)"
            @keydown.space.prevent="color = option.value"
            @keyup.space.prevent="emit('chosen')"
            @keydown.enter.prevent="choose(option.value)"
            @keydown.down.exact.prevent="moveColor(index, 1)"
            @keydown.right.exact.prevent="moveColor(index, 1)"
            @keydown.up.exact.prevent="moveColor(index, -1)"
            @keydown.left.exact.prevent="moveColor(index, -1)"
        ></div>
    </div>
</template>

<script lang="ts" setup>
import { computed, useTemplateRef } from 'vue';
import { THREAD_CATEGORY_COLORS_OPTIONS } from '~/constants/messageHub';

const color = defineModel<string>({ required: true });

const emit = defineEmits<{
    chosen: [];
}>();

const colorsRef = useTemplateRef<HTMLElement>('colorsRef');

const colorTabStop = computed(() => {
    const checked = THREAD_CATEGORY_COLORS_OPTIONS.findIndex((option) => option.value === color.value);

    return -1 === checked ? 0 : checked;
});

const choose = (value: string) => {
    color.value = value;
    emit('chosen');
};

const moveColor = (index: number, step: number) => {
    const next = (index + step + THREAD_CATEGORY_COLORS_OPTIONS.length) % THREAD_CATEGORY_COLORS_OPTIONS.length;
    const option = THREAD_CATEGORY_COLORS_OPTIONS[next];

    if (option) {
        color.value = option.value;
    }

    colorsRef.value?.querySelectorAll<HTMLElement>('[role="radio"]')[next]?.focus();
};
</script>
